import { requestApiCommon } from "@dx-hrsol/util-kit";
import { AXIOS_INSTANCE } from "../config";

export const requestApi = new requestApiCommon(AXIOS_INSTANCE);
